import { makeAutoObservable } from 'mobx';
import { io, Socket } from 'socket.io-client';

class SocketStore {
  socket: Socket | null = null;
  status: string = 'disconnected';
  taskState: string = '';
  progress: number = 0;
  total: number = 0;

  constructor() {
    makeAutoObservable(this);
  }

  connect() {
    if (!this.socket) {
      const isProd = process.env.NODE_ENV === 'production';
      console.log('[SocketStore] Connecting socket...');
      console.log(`[SocketStore] NODE_ENV: ${process.env.NODE_ENV}`);

      this.socket = isProd
        ? io('/', {
            path: '/api/socket.io',
            transports: ['websocket'],
            forceNew: true,
            autoConnect: true,
          })
        : io({
            forceNew: true,
            autoConnect: true,
          });

      this.socket.on('connect', () => {
        this.status = 'connected';
        console.log('[SocketStore] Socket connected');

        this.socket?.emit('test_event', { data: 'Hi from frontend' });

        this.socket?.on('response_event', (data) => {
          console.log('[SocketStore] Got response from backend:', data);
        });

        this.subscribeToUserUpdate();

        this.socket?.onAny((event, data) => {
          console.log('[SocketStore] Any event:', event, data);
        });
      });

      this.socket.on('disconnect', () => {
        this.status = 'disconnected';
        console.log('[SocketStore] Socket disconnected');
      });

      this.socket.on('connect_error', (error) => {
        console.error('[SocketStore] Connection error:', error);
      });

      this.socket.on('error', (error) => {
        console.error('[SocketStore] General socket error:', error);
      });
    }
  }

  subscribeToUserUpdate() {
    const userId = localStorage.getItem('userId');
    if (userId && this.socket) {
      const channel = `user_update_${userId}`;
      console.log(`[SocketStore] Subscribing to ${channel}`);

      this.socket.on(channel, (data) => {
        console.log(`[SocketStore] Update for user ${userId}:`, data);
        this.taskState = data.message || '';
        this.progress = data.progress ?? 0;
        this.total = data.total ?? 0;
      });
    } else {
      console.warn(
        '[SocketStore] Cannot subscribe – userId or socket not available yet.'
      );
    }
  }
}

const socketStore = new SocketStore();
export default socketStore;
